module.exports = __webpack_public_path__ + "static/media/ramen-light.361b7662.gif";